import { SavedMaps } from "@softmax/product-ux/account";
import { useSyncExternalStore } from "react";

function subscribeToStorage(onChange: () => void) {
  window.addEventListener("storage", onChange);
  return () => window.removeEventListener("storage", onChange);
}
function readSavedMaps() {
  return window.localStorage.getItem("observatory-map-studio-shelf-v1");
}

export function AccountSavedMaps() {
  const savedMaps = useSyncExternalStore(
    subscribeToStorage,
    readSavedMaps,
    () => null,
  );

  if (savedMaps === null) return null;

  const download = () => {
    const url = URL.createObjectURL(
      new Blob([savedMaps], { type: "application/json" }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.download = "saved-maps.json";

    try {
      link.click();
    } finally {
      URL.revokeObjectURL(url);
    }
  };
  return <SavedMaps onDownload={download} />;
}
